export default "__VITE_ASSET__D8_1lPwp__"